<template>
  <div class="container">
    <section class="list_box">
      <section class="list_item border-bottom" v-for="item in fileList" :key="item.id" @click="downFile(item.fileUrl,item.fileName)">
        <img class="list_item_left" :src="item.fileName | imgType" />
        <section class="list_item_right">
          <h3>{{item.fileName}}</h3>
          <section class="item_right_bottom">
            <p class="date">{{time | timeType}}</p>
            <!-- <p class="size">8.83M</p> -->
          </section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import util from '../../utils/util.js'
import {serversHttp} from '../../utils/api.js';
export default {
  name: "fileList",
  data() {
    return {
      fileList:[],
      time:''
    };
  },
  filters:{
    imgType(val){
      if(val.indexOf('doc') > -1){
        return require('../../assets/images/icon_word.png')
      }else if(val.indexOf('pdf') > -1){
        return require('../../assets/images/icon_pdf.png')
      }else if(val.indexOf('ppt') > -1){
        return require('../../assets/images/icon_ppt.png')
      }else if(val.indexOf('xlsx') > -1){
        return require('../../assets/images/icon_excel.png')
      }else{
        return require('../../assets/images/icon_image.png')
      }
    },
    timeType(val){
      return util.formatTime(new Date(Number(val)),4)
    }
  },
  methods: {
    downFile(file ,fileName){

      if(fileName.indexOf('png') > -1|| fileName.indexOf('jpg') > -1||fileName.indexOf('jpeg') > -1  ||fileName.indexOf('gif') > -1 ||fileName.indexOf('tif') > -1){
         localStorage.setItem("src", file);
         // 跳转地址
         this.$router.push(`/yuelanImage`);
        return;
      }
       if(fileName.indexOf('pdf') > -1){
            var url =serversHttp+ "servers.api/systemApi/exportFile?url="+encodeURIComponent(file)
            console.log(url);
            localStorage.setItem("src", url);
          // 跳转地址
            this.$router.push(`/yulanpdf`);
            return
        }

       var u = navigator.userAgent
       if(!(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1)){

          // console.log(history.length)
          // history.go(-(history.length-2))
          // var url1 =serversHttp+ "servers.api/systemApi/exportFile?url="+encodeURIComponent(file)
          // window.open(url1)
          // var url1 ="https://ow365.cn/?i=18679&ssl=1&furl=" + encodeURIComponent(file)
         // var url1 ='https://www.xdocin.com/xdoc?_func=to&_format=html&_cache=1&_xdoc='+encodeURIComponent(file)
          var url1 ="https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(file)
          console.log(url1);
          localStorage.setItem("src", url1);
         // 跳转地址
         this.$router.push(`/iframePage`)
       }else{
          //var url1 ="https://ow365.cn/?i=18679&ssl=1&furl=" + encodeURIComponent(file)
          // var url1 ='https://www.xdocin.com/xdoc?_func=to&_format=html&_cache=1&_xdoc='+encodeURIComponent(file)
          // console.log(url1);
           var url1 ="https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(file)
           localStorage.setItem("src", url1);

         // 跳转地址
         //localStorage.setItem("src", file);
         this.$router.push(`/iframePage`);
       }

    }
  },
  created(){
    let fileList = JSON.parse(localStorage.getItem('fileList'));
    console.log(fileList)
    this.fileList = fileList;
    this.time = this.$route.query.time
  },
  destroyed(){
    localStorage.removeItem("fileList")
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
}
.list_item {
  padding: 28px;
  .flex();
  align-items: center;
  .list_item_left {
    display: block;
    width: 40px;
    height: 40px;
    margin-right: 26px;
  }
  .list_item_right {
    flex: 1;
    h3 {
      font-size: 30px;
      color: rgba(24, 24, 24, 1);
      line-height: 42px;
      margin-bottom: 10px;
    }
    .item_right_bottom {
      .flex();
      justify-content: space-between;
      .date {
        font-size: 28px;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
      }
      .size {
        font-size: 28px;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
      }
    }
  }
}
</style>